exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".time-picker .spinners {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n", ""]);
